import React from 'react';
import { Modal, Progress } from '@gerdau/hefesto';
import { Container, ModalOutContainer, Subtitle } from './styles';

interface Props {
  enabled: boolean;
  title: string;
  message: string;
}

const LoadingModal = ({ enabled, title, message }: Props) => {
  if (!enabled) {
    return null;
  }

  return (
    <ModalOutContainer>
      <Modal
        buttons={{
          right: {
            children: 'Fechar',
            name: 'continue-loading',
            onClick: () => null,
            type: 'button',
            variant: 'primary'
          }
        }}
        modalSize="sm"
        title={title}
      >
        <Container>
          <Subtitle>{message}</Subtitle>
          <Progress infinite showPercentNumber={false} />
        </Container>
      </Modal>
    </ModalOutContainer>
  );
};

export default LoadingModal;
